import React, { useEffect, useRef, useState } from "react";
import { LuChevronLeft, LuLayoutGrid, LuMoreVertical, LuPencil, LuRedo2, LuSearch, LuUndo2 } from "react-icons/lu";
import { BOT_LIST_CSS, useFullBleed } from "./BotListKit";
import { useFillHeight } from "./BotCard";

const CANVAS_CSS = `
.su-canvas-root { margin: 0 -1rem; width: calc(100% + 2rem); display: flex; flex-direction: column; overflow: hidden; }
.su-canvas-area { position: relative; flex: 1; min-height: 0; background: var(--su-bg); }
.su-kit .node-editor-body .form-control, .su-kit .node-editor-body textarea.form-control { border: 1px solid var(--su-line) !important; border-radius: 10px !important; box-shadow: none !important; background: var(--su-surface) !important; color: var(--su-ink) !important; font-family: inherit; font-size: 14px !important; }
.su-kit .node-editor-body .form-control:focus { border-color: var(--su-sky) !important; }
#body-dark .su-kit input.cmn-toggle-round-flat + label { width: 34px !important; height: 20px !important; padding: 0 !important; border-radius: 99px !important; background-color: var(--su-control) !important; }
#body-dark .su-kit input.cmn-toggle-round-flat:checked + label { background-color: var(--su-wa) !important; }
#body-dark .su-kit input.cmn-toggle-round-flat + label:before { display: none !important; }
#body-dark .su-kit input.cmn-toggle-round-flat + label:after { top: 2px !important; left: 2px !important; bottom: auto !important; width: 16px !important; height: 16px !important; margin: 0 !important; border-radius: 50% !important; background-color: #ffffff !important; }
#body-dark .su-kit input.cmn-toggle-round-flat:checked + label:after { margin-left: 14px !important; background-color: #ffffff !important; }
.su-seg3 { display: grid; grid-auto-flow: column; grid-auto-columns: 1fr; gap: 6px; margin-bottom: 12px; }
.su-seg3 button { padding: 8px; border: 1px solid var(--su-line); border-radius: 9px; background: var(--su-surface); color: var(--su-ink-2); font-size: 13px; font-weight: 600; cursor: pointer; }
.su-seg3 button.on { border-color: var(--su-accent-ink); background: var(--su-chip-on); color: var(--su-accent-ink); }
.su-kit .node-editor-body input::placeholder, .su-kit .node-editor-body textarea::placeholder { color: var(--su-ink-3); font-style: normal; }
.su-cb { position: relative; z-index: 950; display: flex; align-items: center; gap: 8px; min-height: 60px; padding: 8px 14px; border-bottom: 1px solid var(--su-line); background: var(--su-surface); flex-shrink: 0; }
.su-cb-back { display: inline-flex; align-items: center; gap: 2px; padding: 4px 6px; border: none; border-radius: 8px; background: none; color: var(--su-ink-2); font-size: 13px; font-weight: 600; cursor: pointer; }
.su-cb-back:hover { background: var(--su-raised); }
.su-cb-sep { width: 1px; height: 22px; margin: 0 4px; background: var(--su-line); flex-shrink: 0; }
.su-cb-name { display: inline-flex; align-items: center; gap: 8px; min-width: 0; max-width: 340px; padding: 4px 8px; border: none; border-radius: 8px; background: none; color: var(--su-ink); font-size: 19px; font-weight: 600; cursor: pointer; }
.su-cb-name:hover { background: var(--su-raised); }
.su-cb-name span { white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
.su-cb-name .su-ic { color: var(--su-ink-3); }
.su-cb-tabs { display: flex; gap: 4px; padding: 3px; border-radius: 10px; background: var(--su-raised); flex-shrink: 0; }
.su-cb-tabs button { display: inline-flex; align-items: center; gap: 6px; padding: 6px 12px; border: none; border-radius: 8px; background: none; color: var(--su-ink-3); font-size: 13px; font-weight: 600; white-space: nowrap; cursor: pointer; }
.su-cb-tabs button.on { background: var(--su-surface); color: var(--su-accent-ink); }
.su-cb-right { display: flex; align-items: center; gap: 4px; margin-left: auto; min-width: 0; }
.su-cb-find { display: flex; align-items: center; gap: 8px; width: 230px; height: 38px; padding: 0 10px 0 12px; border: 1px solid var(--su-line); border-radius: 11px; background: var(--su-surface); color: var(--su-ink-3); font-size: 14px; cursor: text; }
.su-cb-find:hover { border-color: var(--su-control); }
.su-cb-find em { margin-left: auto; font-style: normal; font-size: 11px; font-weight: 600; color: var(--su-ink-4); }
.su-cb-ib { position: relative; width: 38px; height: 38px; flex-shrink: 0; display: grid; place-items: center; border: none; border-radius: 10px; background: none; color: var(--su-ink); cursor: pointer; }
.su-cb-ib:hover:not(:disabled), .su-cb-ib.on { background: var(--su-raised); }
.su-cb-ib:disabled { color: var(--su-control); cursor: default; }
.su-cb-ib i { position: absolute; top: 7px; right: 7px; width: 8px; height: 8px; border-radius: 50%; border: 1.5px solid var(--su-surface); box-sizing: content-box; }
.su-cb-menu { position: relative; }
.su-cb-menu .su-pop { top: 44px; right: 0; width: 210px; }
.su-cb-menu .su-pop-row i { width: 8px; height: 8px; margin-left: auto; border-radius: 50%; }
.su-cb-spin { animation: su-cb-spin 0.9s linear infinite; }
@keyframes su-cb-spin { to { transform: rotate(360deg); } }
`;

export const CanvasShell = ({ children }) => {
    const [ref, height] = useFillHeight(0);
    useFullBleed(ref);
    return (
        <div ref={ref} className="su-kit su-canvas-root" style={{ height: height ? `${height}px` : undefined }}>
            <style>{BOT_LIST_CSS}</style>
            <style>{CANVAS_CSS}</style>
            {children}
        </div>
    );
};

const BarMenu = ({ items, dotColor }) => {
    const [open, setOpen] = useState(false);
    const ref = useRef(null);

    useEffect(() => {
        if (!open) return undefined;
        const onMouseDown = (event) => {
            if (ref.current && !ref.current.contains(event.target)) setOpen(false);
        };
        const onKeyDown = (event) => {
            if (event.key === "Escape") setOpen(false);
        };
        document.addEventListener("mousedown", onMouseDown);
        document.addEventListener("keydown", onKeyDown);
        return () => {
            document.removeEventListener("mousedown", onMouseDown);
            document.removeEventListener("keydown", onKeyDown);
        };
    }, [open]);

    return (
        <div ref={ref} className="su-cb-menu">
            <button
                type="button"
                className={`su-cb-ib${open ? " on" : ""}`}
                aria-label="Más opciones"
                aria-haspopup="menu"
                aria-expanded={open}
                data-tooltip-id="my-tooltip"
                data-tooltip-content={dotColor ? "Más opciones · hay problemas en el flujo" : "Más opciones"}
                onClick={() => setOpen((value) => !value)}
            >
                <LuMoreVertical className="su-ic" size={18} />
                {dotColor && <i style={{ backgroundColor: dotColor }} />}
            </button>
            {open && (
                <div className="su-pop" role="menu">
                    {items.map((item) => {
                        const Icon = item.icon;
                        return (
                            <button
                                key={item.label}
                                type="button"
                                role="menuitem"
                                className="su-pop-row"
                                onClick={() => {
                                    setOpen(false);
                                    item.onClick();
                                }}
                            >
                                <Icon className="su-ic" size={16} />
                                {item.label}
                                {item.dot && <i style={{ backgroundColor: item.dot }} />}
                            </button>
                        );
                    })}
                </div>
            )}
        </div>
    );
};

const BotCanvasBar = ({
    name,
    onBack,
    onEditName,
    readOnly,
    onRestoreBack,
    onRestore,
    tabs,
    activeTab,
    onTab,
    workspaceActions,
    onSearch,
    onUndo,
    onRedo,
    canUndo,
    canRedo,
    onLayout,
    layoutRunning,
    menuItems,
    dotColor,
}) => (
    <div className="su-cb">
        <button type="button" className="su-cb-back" onClick={onBack}>
            <LuChevronLeft className="su-ic" size={16} />
            Bots
        </button>
        <span className="su-cb-sep" />
        {!readOnly && (
            <button type="button" className="su-cb-name" title={name} data-tooltip-id="my-tooltip" data-tooltip-content="Editar nombre" onClick={onEditName}>
                <span>{name}</span>
                <LuPencil className="su-ic" size={15} />
            </button>
        )}
        {!readOnly && tabs && (
            <div className="su-cb-tabs" role="tablist" aria-label="Vista del bot">
                {tabs.map((tab) => {
                    const Icon = tab.icon;
                    return (
                        <button key={tab.value} type="button" role="tab" aria-selected={activeTab === tab.value} className={activeTab === tab.value ? "on" : ""} onClick={() => onTab(tab.value)}>
                            {Icon && <Icon className="su-ic" size={14} />}
                            {tab.label}
                        </button>
                    );
                })}
            </div>
        )}
        <div className="su-cb-right">
            {readOnly ? (
                <>
                    <button type="button" className="su-btn ghost" onClick={onRestoreBack}>
                        Volver
                    </button>
                    <button type="button" className="su-btn" style={{ marginLeft: "4px" }} onClick={onRestore}>
                        Restaurar esta versión
                    </button>
                </>
            ) : workspaceActions ? (
                workspaceActions
            ) : (
                <>
                    <button type="button" className="su-cb-find" aria-label="Buscar nodo" onClick={onSearch}>
                        <LuSearch className="su-ic" size={16} />
                        Buscar nodo
                        <em>Ctrl+F</em>
                    </button>
                    <span className="su-cb-sep" />
                    <button type="button" className="su-cb-ib" aria-label="Deshacer" disabled={!canUndo} data-tooltip-id="my-tooltip" data-tooltip-content="Deshacer (Ctrl+Z)" onClick={onUndo}>
                        <LuUndo2 className="su-ic" size={18} />
                    </button>
                    <button type="button" className="su-cb-ib" aria-label="Rehacer" disabled={!canRedo} data-tooltip-id="my-tooltip" data-tooltip-content="Rehacer (Ctrl+Shift+Z)" onClick={onRedo}>
                        <LuRedo2 className="su-ic" size={18} />
                    </button>
                    <button type="button" className="su-cb-ib" aria-label="Ordenar nodos" disabled={layoutRunning} data-tooltip-id="my-tooltip" data-tooltip-content="Reordena el flujo automáticamente" onClick={onLayout}>
                        <LuLayoutGrid className={`su-ic${layoutRunning ? " su-cb-spin" : ""}`} size={18} />
                    </button>
                    <span className="su-cb-sep" />
                    <BarMenu items={menuItems} dotColor={dotColor} />
                </>
            )}
        </div>
    </div>
);

export default BotCanvasBar;
